export interface PermissionGrant {
  read: boolean;
  write: boolean;
}

/**
 * Feature key için read kontrolü.
 * Parent module (Hesaplama) child'a (Hesaplama.GecmisYillar) miras VERMEZ.
 * Module key için alt feature grant'ları sayılır (Hesaplama → Hesaplama.*).
 */
export function grantAllowsRead(
  grants: ReadonlyMap<string, PermissionGrant>,
  permissionKey: string,
): boolean {
  const exact = grants.get(permissionKey);
  if (exact?.read || exact?.write) {
    return true;
  }

  for (const [key, grant] of grants.entries()) {
    if (key.startsWith(`${permissionKey}.`) && (grant.read || grant.write)) {
      return true;
    }
  }

  return false;
}

/**
 * Feature key için write kontrolü — parent'tan child'a miras yok.
 */
export function grantAllowsWrite(
  grants: ReadonlyMap<string, PermissionGrant>,
  permissionKey: string,
): boolean {
  const exact = grants.get(permissionKey);
  if (exact?.write) {
    return true;
  }

  for (const [key, grant] of grants.entries()) {
    if (key.startsWith(`${permissionKey}.`) && grant.write) {
      return true;
    }
  }

  return false;
}
